const exceptions = {
    geral: ['APICustomException'],
    operacao: ['OperacaoComIdentificadorDuplicadoException', 'OperacaoEmStatusInvalidoException']
};

export default function possuiExceptionMapeada(exceptionResponse) {
    const { response } = exceptionResponse;
    let exceptionMapeada = false;

    if (
        !response.data ||
        !response.data.exception ||
        response.data.exception === undefined
    ) {
        return false;
    }

    Object.keys(exceptions).forEach(
        e =>
            (exceptionMapeada = exceptions[e].some(
                item => item === response.data.exception
            ))
    );

    return exceptionMapeada;
}
